// Only add the hyphen when there are numbers after the hyphen so that formatted input never ends with a hyphen
export const getConfirmationCodeFormat = (input: string): string => {
  if (!input || input.length >= 12) {
    return '###-###-###-###'
  }
  const segments = Array(Math.floor(input.length / 3) + 1).fill('###')
  if (input.length > 0 && input.length % 3 === 0) {
    segments.pop()
    segments[segments.length - 1] = '####'
  }
  return segments.join('-')
}
